import React, { useState, useEffect } from 'react';
import { Bar } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";

const AccettateRankingTableSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState(false);
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const shaped = { items: [...(filterModel.items || []), { field: "status", operator: "equals", value: "accepted" }] };
        setLocalFilterModel(shaped);
        setLocalDrawable(true);
    }, [filterModel]);

    return (drawable && localDrawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Bar
                        title={t("Accepted by Area")}
                        dataProviderName={'statisticsviews/acceptedperarea/aggregated/views_opportunities_proposal/_related_area_name'}
                        filters={localFilterModel}
                        direction={'horizontal'}
                    />
                </Box>
                <Box className="report-item">
                    <Bar
                        title={t("Accepted by Shop")}
                        dataProviderName={"statisticsviews/acceptedpershop/aggregated/views_opportunities_proposal/_related_shop_name"}
                        filters={localFilterModel}
                        direction={'horizontal'}
                    />
                </Box>
                <Box className="report-item">
                    <Bar
                        title={t("Accepted by Source")}
                        dataProviderName={"statisticsviews/acceptedpersource/aggregated/views_opportunities_proposal/_related_source_name"}
                        filters={localFilterModel}
                        direction={'horizontal'}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default AccettateRankingTableSet;
